import dayjs from "dayjs"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"

import { canada2026DisplayDeltaMinutes } from "./canada2026Time"
import { resolveIanaTimeZone } from "./timeZoneUtils"

dayjs.extend(utc)
dayjs.extend(timezone)

const originalInstanceTz = dayjs.prototype.tz
const originalStaticTz = dayjs.tz

function coerceZone(zone) {
  if (zone == null || zone === "") return zone
  return resolveIanaTimeZone(zone)
}

dayjs.prototype.tz = function patchedTz(timeZone, keepLocalTime) {
  if (timeZone === undefined) return originalInstanceTz.call(this)
  const zone = coerceZone(timeZone)
  const zoned = originalInstanceTz.call(this, zone, keepLocalTime)
  if (keepLocalTime) return zoned
  const delta = canada2026DisplayDeltaMinutes(zone, this.toDate(), zoned.utcOffset())
  if (!delta) return zoned
  return zoned.add(delta, "minute")
}

function patchedStaticTz(...args) {
  const next = [...args]
  const last = next[next.length - 1]
  if (typeof last === "string") {
    next[next.length - 1] = coerceZone(last)
  }
  return originalStaticTz(...next)
}

Object.assign(patchedStaticTz, originalStaticTz)
dayjs.tz = patchedStaticTz
